export enum ModuleEnum {
  Briefing = 'Briefing',
  Growth = 'Growth',
  Inspire = 'Inspire',
  Planning = 'Planning',
  Audience = 'Audience',
  Reporting = 'Reporting',
  Activation = 'Activation',
  Investment = 'Activation',
  Cockpit = 'Cockpit',
  Config = 'Config',
  CampaignMonitor = 'CampaignMonitor',
  Unknown = '',
}

export enum ClientLoginScreenEnum {
  DaimlerLoginScreen = 'DaimlerLoginScreen',
  ColaLoginScreen = 'ColaLoginScreen',
  StarWarsLoginScreen = 'StarWarsLoginScreen',
}

export enum SharepointEntities {
  Cookie = 'Cookie',
  CookieDeclaration = 'CookieDeclaration',
  HelpSection = 'Help-Section',
  Glossary = 'Glossary',
}

export enum CookieBannerActions {
  Accept = 'Accept',
  Decline = 'Decline',
}

export enum NotificationTypes {
  Success = 'success',
  Warning = 'warning',
  Info = 'info',
  Error = 'error',
}

export enum ModulesPermissions {
  COCKPIT = 'Cockpit.Home',
  WEBFRAME_HEADER_MAKE_IT_RIGHT_AUDIENCE = 'Webframe.Header.MakeItRight.Audience',
  WEBFRAME_HEADER_MAKE_IT_RIGHT_BRIEF = 'Webframe.Header.MakeItRight.Brief',
  WEBFRAME_HEADER_MAKE_IT_RIGHT_PATH_TO_GROWTH = 'Webframe.Header.MakeItRight.PathToGrowth',
  WEBFRAME_HEADER_MAKE_IT_MAGIC_DESIGN = 'Webframe.Header.MakeItMagic.Design',
  WEBFRAME_HEADER_MAKE_IT_MAGIC_INSPIRE = 'Webframe.Header.MakeItMagic.Inspire',
  WEBFRAME_HEADER_MAKE_IT_WORK_ACTIVATE = 'Webframe.Header.MakeItWork.Activate',
  WEBFRAME_HEADER_MAKE_IT_WORK_OPTIMIZE_AND_REPORT = 'Webframe.Header.MakeItWork.OptimizeAndReport',
  CONFIG = 'Config',
  CAMPAIGN_MONITOR = 'CampaignMonitor',
  WEBFRAME_CONFIG_COOKIE = 'Webframe.Config.Cookie',
  WEBFRAME_CONFIG_COOKIE_DECLARATION = 'Webframe.Config.CookieDeclaration',
  WEBFRAME_CONFIG_GLOSSARY = 'Webframe.Config.Glossary',
  WEBFRAME_CONFIG_HELP_SECTION = 'Webframe.Config.HelpSection',
}

export enum FeatureFlagsEnum {
  UseConfigModule = 'UseConfigModule',
}
